import { render, staticRenderFns } from "./WarrantyRequest.vue?vue&type=template&id=2cef3b6a&"
import script from "./WarrantyRequest.vue?vue&type=script&lang=js&"
export * from "./WarrantyRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports